import { addFilter } from '@wordpress/hooks';
import { BaseControl, Notice, SelectControl, ToggleControl, TextControl, TextareaControl } from '@wordpress/components'

const { createHigherOrderComponent } = wp.compose;
const { InspectorControls } = wp.blockEditor;
const { PanelBody, PanelRow } = wp.components;

function addASMUnfoldAttribute(settings) {
	if (typeof settings.attributes !== 'undefined') {
		if (settings.name == 'core/navigation-link') {
			settings.attributes = Object.assign(settings.attributes, {
				'asm_unfold': {
					type: 'boolean',
				},
				'asm_item_depth': {
					type: 'integer',
				},
				'asm_orderby': {
					type: 'string',
				},
				'asm_item_titles': {
					type: 'string',
				}
			});
		}
	}
	return settings;
}

addFilter(
	'blocks.registerBlockType',
	'asm/unfold',
	addASMUnfoldAttribute
);

const asmUnfoldControls = createHigherOrderComponent((BlockEdit) => {
	return (props) => {
		return (
			<>
				<BlockEdit key="edit" {...props} />
				{props.attributes.kind === 'post-type' && props.attributes.type === 'page'
					? <InspectorControls>
						<PanelBody title="Auto Submenu" initialOpen={false}>
							<BaseControl>
								<ToggleControl
									id='asm_unfold'
									key='asm_unfold'
									label={wp.i18n.__('Create submenu containing child pages', 'auto-submenu')}
									checked={!!props.attributes.asm_unfold}
									onChange={(newValue) => props.setAttributes({ asm_unfold: newValue })}
								/>
							</BaseControl>
							{props.attributes.asm_unfold
								? <>
									<BaseControl>
										<TextControl
											label={<>
												{wp.i18n.__('Nesting depth', 'auto-submenu')} (max 3)
											</>}
											value={props.attributes.asm_item_depth > 0 ? props.attributes.asm_item_depth : 3}
											onChange={(newValue) => props.setAttributes({ asm_item_depth: isNaN(+newValue) || (+newValue) > 3 ? 3 : +newValue })}
										/>
									</BaseControl>
									<BaseControl>
										<SelectControl
											disabled
											label={wp.i18n.__('Order by', 'auto-submenu')}
											value={props.attributes.asm_orderby ?? 'none'}
											options={[
												{ label: wp.i18n.__('Menu Order', 'auto-submenu'), value: 'menu_order' }
											]}
											onChange={(newValue) => props.setAttributes({ asm_orderby: newValue })}
										/>
									</BaseControl>
									<BaseControl>
										<TextareaControl
											label={<>
												{wp.i18n.__('Navigation Label', 'auto-submenu')}
											</>}
											value={props.attributes.asm_item_titles ?? '%post_title'}
											onChange={(newValue) => props.setAttributes({ asm_item_titles: newValue })}
										/>
									</BaseControl>
									<BaseControl>
										{wp.i18n.__('The navigation label may be customized using wildcards such as %post_title. See documentation.', 'auto-submenu')}
									</BaseControl>
								</>
								: null}
						</PanelBody>
					</InspectorControls>
					: null}
			</>
		);
	};
}, 'withMyPluginControls');

wp.hooks.addFilter(
	'editor.BlockEdit',
	'asm/unfold',
	asmUnfoldControls
);
